<template>
  <div class="invisible-scrollbar">
    <v-card style="display: contents">
      <div class="mx-3">
        <div class="pt-8 text-h6 font-weight-bold page-title">
          Zone Management
        </div>
        <v-card-text>
          <v-card elevation="10" class="pa-4 my-4 rounded-lg">
            <v-row>
              <v-col cols="12" md="2" class="pt-5">
                <v-select
                  :items="['Active', 'InActive']"
                  label="Status"
                  v-model="activeSearch"
                  required
                  clearable
                  outlined
                  dense
                ></v-select>
              </v-col>
              <v-col cols="12" md="4" class="pt-5">
                <v-text-field
                  :label="$t('message.Search')"
                  append-icon="mdi-database-search-outline"
                  v-model="search"
                  @keyup.enter="SearchDataTenantList(search)"
                  clearable
                  outlined
                  dense
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="6" class="pt-3">
                <v-btn
                  color="primary"
                  class="ma-2 white--text"
                  @click="getDataTenantList()"
                >
                  {{ $t("message.Search") }}
                  <v-icon right>mdi-magnify</v-icon>
                </v-btn>
                <v-btn
                  color="green"
                  class="ma-2 white--text"
                  @click="OpenDataDialog('create', null)"
                >
                  {{ $t("message.Create") }}
                  <v-icon right>mdi-plus</v-icon>
                </v-btn>
              </v-col>
            </v-row>
          </v-card>

          <v-card elevation="10" class="pa-4 my-4 rounded-lg">
            <v-data-table
              :headers="headers"
              :items="ListData"
              hide-default-footer
              class="data-table"
              :items-per-page="itemsPerPage"
              :page.sync="page"
              single-line
              hide-details
            >
              <template
                v-if="!$vuetify.breakpoint.smAndDown"
                v-slot:item="{ item, index }"
              >
                <tr>
                  <td class="cell">{{ no_run + (index + 1) }}</td>
                  <td class="cell">{{ item.zoneName }}</td>
                  <td class="cell">{{ item.zoneNameTH }}</td>
                  <td class="py-2 text-center">
                    <v-btn
                      :color="GetColor(item.active)"
                      rounded
                      class="text-capitalize"
                      depressed
                      style="width: 120px"
                    >
                      <span :style="{ color: GetColorText(item.active) }">
                        {{ item.active ? "Active" : "Inactive" }}
                      </span>
                    </v-btn>
                  </td>
                  <td class="text-center">
                    <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      color="orange"
                      @click="OpenDataDialog('edit', item.tenantID)"
                    >
                      <v-icon>mdi-pencil-outline</v-icon>
                    </v-btn>

                    <v-btn
                      class="mx-1"
                      fab
                      small
                      dark
                      :color="item.active ? 'red' : 'green'"
                    >
                      <v-icon>mdi-trash-can-outline</v-icon>
                    </v-btn>
                  </td>
                </tr>
              </template>
            </v-data-table>
            <v-row class="mt-4" align="center" justify="space-between">
              <v-col cols="12" md="3"></v-col>

              <v-col cols="12" md="4" class="text-center">
                <v-pagination
                  v-model="page"
                  :length="pageCount"
                  @input="ChangePage(page)"
                ></v-pagination>
              </v-col>

              <v-col cols="12" md="2">
                <v-autocomplete
                  dense
                  solo
                  v-model="itemsPerPage"
                  @input="ChangePerPage(itemsPerPage)"
                  :items="items"
                  label="Items/page"
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-card>
        </v-card-text>
      </div>
    </v-card>

    <v-dialog v-model="TenantDetailDialog" persistent max-width="820px">
      <v-card class="rounded-xl">
        <v-card-title
          class="py-3 px-6 d-flex align-center"
          style="background: #1d2939; color: white"
        >
          <span class="text-h6 font-weight-bold">
            {{ $t("message.Tenant") }}
          </span>
          <v-spacer></v-spacer>
          <v-btn icon @click="TenantDetailDialog = false">
            <v-icon color="white">mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="px-8 pt-6 pb-10">
          <v-row class="mt-2">
            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.TenantName')"
                dense
                outlined
                v-model="TenantName"
              />
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                :label="$t('message.TenantNameTH')"
                dense
                outlined
                v-model="TenantNameTH"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="4">
              <v-radio-group row v-model="Active" class="mt-1">
                <v-radio :label="$t('message.Active')" value="1"></v-radio>
                <v-radio :label="$t('message.InActive')" value="2"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
          <v-row justify="center">
            <v-col cols="12" md="3">
              <v-btn
                v-if="!EditStatus"
                block
                x-large
                color="#1D9D58"
                class="white--text rounded-lg"
                @click="AddDataUser()"
              >
                {{ $t("message.Create") }}
              </v-btn>
              <v-btn
                v-else
                block
                x-large
                color="#1D9D58"
                class="white--text rounded-lg"
                @click="UpdateDataUser()"
              >
                {{ $t("message.Update") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="LoadingDialog" persistent width="auto">
      <v-card
        class="pa-6 d-flex flex-column align-center justify-center"
        elevation="8"
        rounded="xl"
      >
        <v-progress-circular
          indeterminate
          color="indigo"
          size="70"
          width="6"
        ></v-progress-circular>
        <span class="mt-4 text-subtitle-1 font-weight-medium"
          >Loading, please wait...</span
        >
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from "axios";
import enurl from "@/api/environment";
import Swal from "sweetalert2/dist/sweetalert2.js";

export default {
  name: "Zone",
  components: {},
  data() {
    return {
      url: enurl.apiUrl,
      LoadingDialog: false,
      items: [10, 15, 20, 50, 100],
      pageCount: 0,
      page: 1,
      itemsPerPage: 10,
      search: "",
      activeSearch: "",
      no_run: 0,

      ListData: [],
      TenantID: null,
      TenantNameTH: "",
      TenantName: "",
      Active: 1,
      EditStatus: false,
      TenantList: [],
      TenantDetailDialog: false,
    };
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t("message.No"),
          sortable: false,
          align: "left",
        },
        {
          text: "ZoneName",
          align: "left",
          sortable: false,
        },
        {
          text: "ZoneNameTH",
          align: "left",
          sortable: false,
        },
        {
          text: "Status",
          align: "center",
          sortable: false,
        },
        {
          text: "Action",
          align: "center",
          sortable: false,
        },
      ];
    },
  },

  async mounted() {
    let self = this;
    await self.getDataZoneList();
  },

  methods: {
    getDataZoneList() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: self.page,
        perpage: self.itemsPerPage,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == "InActive"
            ? false
            : null,
      };
      axios
        .post(`${self.url}Zone/getDataZoneList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    ChangePage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        page: value,
        perpage: self.itemsPerPage,
        search: self.search == null ? "" : self.search,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == "InActive"
            ? false
            : null,
      };
      axios
        .post(`${self.url}Zone/getDataZoneList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    ChangePerPage(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: self.search,
        page: 1,
        perpage: value,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == "InActive"
            ? false
            : null,
      };
      axios
        .post(`${self.url}Zone/getDataZoneList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    SearchDataTenantList(value) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        search: value,
        page: 1,
        perpage: self.itemsPerPage,
        active:
          self.activeSearch == "Active"
            ? true
            : self.activeSearch == "InActive"
            ? false
            : null,
      };
      axios
        .post(`${self.url}Zone/getDataZoneList`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.ListData = response.data.data.listData;
            self.pageCount = response.data.data.count;
            self.no_run = (self.page - 1) * self.itemsPerPage;
            self.LoadingDialog = false;
          }
          self.LoadingDialog = false;
        })
        .catch(function (error) {
          self.LoadingDialog = false;
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        });
    },

    getDataTenantByID(id) {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        tenantID: id
      };
      axios
        .post(`${self.url}Management/getDataTenantByID`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            self.BindingData(response.data.data);
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    AddDataTenant() {
      let self = this;
      self.LoadingDialog = true;
      let temp = {
        tenantName: self.TenantName,
        tenantNameTH: self.TenantNameTH,
        active: self.Active == "1" ? true : false
      };
      axios
        .post(`${self.url}Management/AddDataTenant`, temp)
        .then(function (response) {
          if (response.data.status == 0) {
            Swal.fire({
              icon: "success",
              text: "Success",
              showConfirmButton: false,
              timer: 1500,
            });
            self.CloseDialog();
            self.getDataTenantList();
          }
        })
        .catch(function (error) {
          const message =
            error?.response?.data?.message ||
            error?.message ||
            "เกิดข้อผิดพลาดในการเชื่อมต่อระบบ";

          Swal.fire({
            icon: "warning",
            width: 900,
            text: message,
          });
        })
        .finally(() => {
          self.LoadingDialog = false;
        });
    },

    BindingData(data){
        let self = this;
        self.TenantID = data.tenantID;
        self.TenantName = data.tenantName;
        self.TenantNameTH = data.tenantNameTH;
        self.Active = data.active == true ? "1" : data.active == false ? "2" : null;
        self.EditStatus = true;
        self.TenantDetailDialog = true;
    },

    OpenDataDialog(type, id) {
      let self = this;
      if (type == "create") {
        self.TenantID = null;
        self.TenantNameTH = "";
        self.TenantName = "";
        self.Active = "";
        self.EditStatus = false;
        self.TenantDetailDialog = true;
      } else {
        self.getDataTenantByID(id);
      }
    },

    CloseDialog(){
        let self = this;
        self.TenantID = null;
        self.TenantNameTH = "";
        self.TenantName = "";
        self.Active = "";
        self.EditStatus = false;
        self.UserDetailDialog = false;
    },

    GetColor(value) {
      if (value == true) {
        return "rgb(92, 184, 92,0.3)";
      } else {
        return "rgb(232, 34, 34,0.3)";
      }
    },

    GetColorText(value) {
      if (value == true) {
        return "rgb(92, 184, 92)";
      } else {
        return "rgb(232, 34, 34)";
      }
    },
  },
};
</script>
<style scoped>
* >>> .v-data-table-header {
  background-color: black;
  color: #ffffff !important;
}
* >>> .v-data-table-header th {
  font-size: 14px !important;
  color: #ffffff !important;
}

@keyframes load {
  0% {
    transform: scaleY(0.4);
  }
  20% {
    transform: scaleY(1);
  }
  40% {
    transform: scaleY(0.4);
  }
  100% {
    transform: scaleY(0.4);
  }
}
@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
.rect2 {
  animation-delay: -1.2s;
}
.rect3 {
  animation-delay: -1.1s;
}
.rect4 {
  animation-delay: -1s;
}
.rect5 {
  animation-delay: -0.9s;
}

.page-title {
  color: #444;
  font-size: 22px;
  margin-left: 1rem;
}

.cell {
  color: #333;
  font-size: 14px;
  padding: 10px 8px;
}

.data-table {
  color: #332f2f;
}

.v-data-table-header th {
  font-weight: 600 !important;
  font-size: 14px !important;
  background-color: #333 !important;
  color: white !important;
}

.rounded-lg {
  border-radius: 12px !important;
}

.rounded-xl {
  border-radius: 16px !important;
}

h1 {
  letter-spacing: 0.5px;
}

.v-text-field input {
  font-size: 15px;
}

.section-header {
  font-size: 16px;
  font-weight: 700;
  color: #1e1e1e;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
}

.rounded-xl {
  border-radius: 16px !important;
}

.v-text-field input,
.v-select input {
  font-size: 15px;
}
</style>
